import type { Timetable } from '../../types/timetable';
import { generateMockLessons, mockLessons } from './lessons';

/**
 * Mock timetables with realistic stats
 */
export const mockTimetables: Timetable[] = [
  {
    id: 'timetable-current',
    name: 'Autumn Term 2025 - Draft 3',
    academicYear: '2025-2026',
    createdAt: '2025-01-15T10:30:00Z',
    createdBy: 'admin-1',
    lastModified: '2025-01-16T14:22:00Z',
    status: 'generated',
    lessons: mockLessons,
    stats: {
      totalLessons: mockLessons.length,
      conflictCount: 8,
      ruleViolations: {
        hard: 0,
        soft: 12,
      },
      curriculumCoverage: 98.5,
      teacherLoad: [
        {
          teacherId: 'teacher-1',
          totalPeriods: 23,
          contractedPeriods: 25,
          utilizationPercentage: 92,
          freePeriods: 2,
          consecutiveStretch: 4,
        },
        {
          teacherId: 'teacher-2',
          totalPeriods: 25,
          contractedPeriods: 25,
          utilizationPercentage: 100,
          freePeriods: 0,
          consecutiveStretch: 5,
        },
        {
          teacherId: 'teacher-3',
          totalPeriods: 20,
          contractedPeriods: 25,
          utilizationPercentage: 80,
          freePeriods: 5,
          consecutiveStretch: 3,
        },
      ],
      roomUtilization: [
        {
          roomId: 'room-101',
          totalPeriods: 25,
          usedPeriods: 24,
          utilizationPercentage: 96,
          conflicts: 0,
        },
        {
          roomId: 'room-sci-lab-1',
          totalPeriods: 25,
          usedPeriods: 22,
          utilizationPercentage: 88,
          conflicts: 1,
        },
      ],
      teacherPreferenceSatisfaction: 87,
      distributionScore: 92,
    },
    version: 3,
    isFinalized: false,
    finalizedYearGroups: [],
  },
  {
    id: 'timetable-previous',
    name: 'Autumn Term 2025 - Draft 2',
    academicYear: '2025-2026',
    createdAt: '2025-01-14T09:15:00Z',
    createdBy: 'admin-1',
    lastModified: '2025-01-14T16:45:00Z',
    status: 'draft',
    lessons: generateMockLessons('timetable-previous'),
    stats: {
      totalLessons: 245,
      conflictCount: 15,
      ruleViolations: {
        hard: 0,
        soft: 18,
      },
      curriculumCoverage: 95.2,
      teacherLoad: [],
      roomUtilization: [],
      teacherPreferenceSatisfaction: 82,
      distributionScore: 85,
    },
    version: 2,
    isFinalized: false,
    finalizedYearGroups: [],
  },
  {
    id: 'timetable-2024',
    name: 'Autumn Term 2024 - Finalized',
    academicYear: '2024-2025',
    createdAt: '2024-09-01T08:00:00Z',
    createdBy: 'admin-1',
    lastModified: '2024-09-15T12:00:00Z',
    status: 'finalized',
    lessons: generateMockLessons('timetable-2024'),
    stats: {
      totalLessons: 238,
      conflictCount: 0,
      ruleViolations: {
        hard: 0,
        soft: 5,
      },
      curriculumCoverage: 100,
      teacherLoad: [],
      roomUtilization: [],
      teacherPreferenceSatisfaction: 95,
      distributionScore: 94,
    },
    version: 5,
    isFinalized: true,
    finalizedYearGroups: ['year-7', 'year-8', 'year-9', 'year-10', 'year-11', 'year-12', 'year-13'],
  },
];

export const getCurrentTimetable = (): Timetable | undefined => {
  return mockTimetables.find((t) => t.status === 'generated' || t.status === 'in-progress');
};

export const getTimetableById = (id: string): Timetable | undefined => {
  return mockTimetables.find((t) => t.id === id);
};
